import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    Input, NgZone,
    Output
} from '@angular/core';
import {FocusMonitor} from "@angular/cdk/a11y";
import {RadioField} from "./radio-field";
import {BaseFieldDirective} from "../base-field.directive";

@Component({
    selector: 'ui-radio-field',
    templateUrl: './radio-field.component.html',
    styleUrls: ['./radio-field.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class RadioFieldComponent extends BaseFieldDirective {
    @Input() public config!: RadioField;

    constructor(
        protected fmRef: FocusMonitor,
        protected elRef: ElementRef<HTMLElement>,
        protected changeDetector: ChangeDetectorRef,
        protected ngZone: NgZone
    ) {
        super(fmRef, elRef, changeDetector, ngZone);
    }

    public atualizaControle = (event: any) => {
        if (this.config!.onValueSelectedFunc) {
            this.config!.onValueSelectedFunc(event.value);
        }
    };
}
